import { render, staticRenderFns } from "./zzl-standard-desc-editor.vue?vue&type=template&id=65d33f65&scoped=true"
import script from "./zzl-standard-desc-editor.vue?vue&type=script&lang=js"
export * from "./zzl-standard-desc-editor.vue?vue&type=script&lang=js"
import style0 from "./zzl-standard-desc-editor.vue?vue&type=style&index=0&id=65d33f65&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d33f65",
  null
  
)

export default component.exports